import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ClienteModel } from 'src/app/cliente/cliente-model';
import { GrupoModel } from 'src/app/models/grupo-model';
import { SetorModel } from 'src/app/models/setor-model';
import { Funcoes, Periodos } from 'src/app/services/funcoes';
import { Services } from 'src/app/services/servicos';

declare var google: any

@Component({
  selector: 'app-localizacao-cliente',
  templateUrl: './localizacao-cliente.component.html',
  styleUrls: ['./localizacao-cliente.component.css']
})
export class LocalizacaoClienteComponent implements OnInit {
  //DECLARAÇÕES
  funcoes: Funcoes = new Funcoes();
  //
  //INI VARIÁVES
  data: ClienteModel
  lista: ClienteModel[];
  selecionados: ClienteModel[];
  listaNoUpdate: ClienteModel[] = [];
  loading: boolean = false;
  submitted: boolean;
  options: any;
  overlays: any[];
  dialogVisible: boolean;
  markerTitle: string;
  selectedPosition: any;
  infoWindow: any;
  geocoder: any;
  address: any;
  draggable: boolean;
  filtros: ClienteModel = new ClienteModel();

  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  total: number
  periodos: Periodos[];
  selecionarPeriodo: string;

  setor: SetorModel[];
  selecionarSetor: SetorModel;
  grupo: GrupoModel[];
  selecionarGrupo: GrupoModel;
  //nome: string
  cliente: ClienteModel[];
  selecionarCliente: ClienteModel;

  constructor(private service: Services,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private config: PrimeNGConfig) {

    //this.origens = this.funcoes.Origens;
  }

  ngOnInit(): void {
    //PESQUISANDO AO ABRIR
    this.Listar();

    //this.listarChamadaFiltros();
    //this.startTimer();

    //setInterval(() => this.Listar(), 30000); // Fetch data every 30 seconds
    
    this.options = {
      center: { lat: -22.9053, lng: -47.0659 },
      zoom: 13,
    };

    this.config.setTranslation({
      accept: 'Aceitar',
      reject: 'Cancelar',
      dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
      dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      today: 'Hoje',
      clear: 'Limpar'
      //translations
    });

    //BUSCANDO SETOR
    try {
      this.service.listarSetor()
        .subscribe(data => {
          if (data.Success) {
            this.setor = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO SETOR 

    //BUSCANDO GRUPO
    try {
      this.service.listarGrupo()
        .subscribe(data => {
          if (data.Success) {
            this.grupo = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO GRUPO 

    //BUSCANDO CLIENTE
    try {
      this.service.listarCliente()
        .subscribe(data => {
          if (data.Success) {
            this.cliente = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO CLIENTE
  }

  pesquisar() {
    this.Listar();

  }

  Listar() {
    this.filtros = {}
    try {
      this.loading = true;

      //this.filtros.filtro_data_inicial = this.data_inicial;
      //this.filtros.filtro_data_final = this.data_final;
      this.filtros.nome = this.selecionarCliente == null ? "" : this.selecionarCliente.nome;
      this.filtros.setor = this.selecionarSetor == null ? "" : this.selecionarSetor.nome;
      this.filtros.grupo = this.selecionarGrupo == null ? "" : this.selecionarGrupo.nome;

      this.service.listarLocCliente(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.lista = data.Response;
            this.total = this.lista.length;
            this.loading = false;
            this.listaNoUpdate = this.lista;
            this.initOverlays(this.lista);
            this.infoWindow = new google.maps.InfoWindow("active");

          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  ddMarker() {
    this.overlays.push(new google.maps.Marker({ position: { lat: this.selectedPosition.lat(), lng: this.selectedPosition.lng() }, title: this.markerTitle, draggable: this.draggable }));
    this.markerTitle = null;
    this.dialogVisible = false;
  }

 

  initOverlays(listaNoUpdate: ClienteModel[]) {
    this.clear();
    if (!this.overlays || !this.overlays.length) {
      //this.overlays = [];

      listaNoUpdate.forEach((element) => {
        let lat = Number(element.latitude.replace(",", "."));
        let lon = Number(element.longitude.replace(",", "."));

        const icon = {
          url: element.endereco_imagem, // url
          scaledSize: new google.maps.Size(45, 45), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(0, 0), // anchor
        };

        this.overlays.push(
          new google.maps.Marker({
            position: { lat: lat, lng: lon },
            label: {
              text: element.nome,
              fontSize: '0px',
            },
            title:
              "Nome: " +
              element.nome +
              "\nEndereço: " +
              element.end_rps +
              " , " +
              element.numero +
              " - " +
              "\nSetor: " +
              element.setor +
              " - " +
              "\nGrupo: " +
              element.grupo,

            //icon: {
            //size: new google.maps.Size(50, 50),
            //origin: new google.maps.Point(0, 0),
            //The origin for this image is (0, 0).
            //origin: new google.maps.Point(0, 0),
            //The anchor for this image is the base of the flagpole at (0, 32).
            //anchor: new google.maps.Point(0, 32),
            //url: "assets/pin-maps.png",
            //},
            options: {
              animation: google.maps.Animation.DROP,
              icon: icon,
            }

          }),


        );
      });
    }
  }

  handleMapClick(event) {
    this.dialogVisible = true;
    this.selectedPosition = event.latLng;
  }
  setarPosicao(map, dados: ClienteModel) {
    // console.log(dados)
    // console.log(this.overlays)
    let position;

    for (let index = 0; index < this.overlays.length; index++) {
      const element = this.overlays[index];
      // console.log(element.title)
      // console.log(element.position)

      if (element.label != null) {
        if (dados.nome == element.label.text) {
          //console.log(element)
          position = element.position;
          this.infoWindow.setContent("" + element.title + "");
          this.infoWindow.open(map, element);
          map.setCenter(position);
          return;
        }
      }
    }
    //map.setCenter(event.overlay.getPosition());
  }
  handleOverlayClick(event) {
    console.log(event)
    let isMarker = event.overlay.getTitle != undefined;
    if (isMarker) {
      let title = event.overlay.getTitle();
      this.infoWindow.setContent("" + title + "");
      this.infoWindow.open(event.map, event.overlay);
      event.map.setCenter(event.overlay.getPosition());
      this.messageService.add({
        severity: "info",
        summary: "Cliente",
        detail: title,

      });
    } else {
      this.messageService.add({
        severity: "info",
        summary: "Cliente",
        detail: "",
      });
    }
  }

  timeLeft: number = 180;
  interval;

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 180;
        //console.log('Atualizou');
        this.Listar();
      }
      //console.log(this.timeLeft);
    }, 1000)
  }

  zoomIn(map) {
    map.setZoom(map.getZoom() + 1);
  }

  zoomOut(map) {
    map.setZoom(map.getZoom() - 1);
  }

  clear() {
    this.overlays = [];
  }

  comparandoDatasTitulosVencer(vencimento: Date) {
    var today = new Date();
    var DataVencimento = new Date(vencimento);
    console.log(DataVencimento);
    console.log(today);

    return (DataVencimento > today);
  }

}
